// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__1ohQQ","disabled":"checkbox_disabled__U6EKF","form":"checkbox_form__OoBiE","checked":"checkbox_checked__9ruIL","game":"checkbox_game__8QvTy"};